export interface userDetailsType{
    muid: string
    email: string | null
    name: string | null
    date_of_birth: string | null,
    addresses : string | null,
    additional_first_name: string | null,
    additional_emails: string | null,
    maiden_name:string | null,
    phones: string | null,
    create_time: string | null
    update_time: string | null
    subscription: string | null
    subscription_status: string | null
    expiring_in_days: string | null
    linked_muid: string | null
    linked_email: string | null
    linked_corp_code: string | null
    linked_create_time: string | null
    linked_expire_time: string | null
    subscription_tier: string | null
}

export type SortType =
| 'ASC'
| 'DESC'

export type SortByType = 'create_time' | 'update_time' | 'email' | 'name' | 'expiring_in_days' | "subscription" | "subscription_tier"

export type RemovalSortByType = 'removal_date' | 'scan_date' | 'confirmator_date'

export type CorpSortByType = 'email'|'onboarding_date'|'name'|'code'|'records_found'|'records_removed'| 'records_removing' | 'expire_time'

export type SubscriptionFilterType = 
  'Parent Family User'|
  'Corporate Grant User'|
  'Child Family User'|
  'Individual User'


export const SubscriptionOptions: SubscriptionFilterType[] = [
  'Parent Family User',
  'Corporate Grant User',
  'Child Family User',
  'Individual User'
];

export type SubscriptionTierFilterType = 'Core' | 'Premium' | 'Ultimate'

export const SubscriptionTierOptions: SubscriptionTierFilterType[] = [
  'Core' , 'Premium' , 'Ultimate'
];

export const FormatLinkedAccountID = {
  'Parent Family User' : 'Child MUID ',
  'Corporate Grant User' : 'Owner BUID',
  'Child Family User' : 'Parent MUID',
  'Individual User' : 'User MUID'
}

export const FormatLinkedAccountType = {
  'Parent Family User' : 'Child ',
  'Corporate Grant User' : 'Owner ',
  'Child Family User' : 'Parent ',
  'Individual User' : 'User '
}

export type RangeFilterType = 'create_time' | 'update_time'

export const RangeFilterOptions = [
  'Create Time',
  'Update Time'
]

export type statusFilterType = 'new' | 'optout_in_progress' | 'pending' | 'removed' | 'failed'| 'waiting_for_confirmation' | 'waiting_for_verification' | 'expired' | 'hold'
export type executionStatusFilterType = 'new' |'optout_in_progress' | 'pending' | 'completed' | 'failed' | 'expired' | 'hold'
export interface RemovalsDataType{
  muid: string
  status: statusFilterType
  execution_status: statusFilterType
  broker: string
  removal_retries: string
  confirmator_retries: string
  broker_source: string
  profile_url: string
  scan_date: string | null
  removal_date: string | null
  confirmator_date: string | null
  broker_children: []
  broker_child_count:number
}

export const statusOptions=[
'new' , 'optout_in_progress' , 'pending' , 'removed' , 'failed', 'waiting_for_confirmation' , 'waiting_for_verification', 'expired' , 'hold'
]

export const executionStatusOptions=[
'new' ,'optout_in_progress' , 'pending' , 'completed' , 'failed', 'expired' , 'hold'
]

export const subscribedSubscriptionStatusFilterOptions: subscriptionStatusStringType[] = ['Active' , 'Expired']

export type booleanStringType = 'True' | 'False'

export const BooleanOptions: booleanStringType[] = ['True' , 'False']

export type subscriptionStatusStringType = 'Free' | 'Expired' | 'Active' | 'Failed'

export type RemovalsReportUsersFilterType = 'Corporate Users' | 'All Users'

export const RemovalsReportFilterOptions : RemovalsReportUsersFilterType[] = ['Corporate Users' , 'All Users']

export const subscriptionStatusFilterOptions : subscriptionStatusStringType[] = ['Free', 'Active' , 'Expired', 'Failed']

export interface SubscriptionsDataType{
  subscription : string,
  count : string
}

export const initialSubData: SubscriptionsDataType[] = [
  {count: '0', subscription: "Individual Users"},
  {count: '0', subscription: "Parent Family Users"},
  {count: '0', subscription: "Child Family Users"},
  {count: '0', subscription: "Corporate Grant Users"}
]

export const yearOptions = [
  '2022', '2023', '2024', '2025', '2026'
]

export type RemovalRangeFilterType = 'Removal Date' | 'Scan Date' | 'Confirmator Date'

export const RemovalRangeFilterOptions = ['Removal Date' , 'Scan Date' , 'Confirmator Date']

export const RemovalBrokerSourceFilterOptions = ['4ScreenMedia', 'meprism','onerep', 'rocketreach']

export const FamilyUserTypeFilterOptions : FamilyUserTypeFilterType[] = ['Parent' , 'Child']

export type FamilyUserTypeFilterType = 'Parent'| 'Child'

export interface CompanyType{
  owner_buid: string
  code : string
  limit: string
  account_type: 'standard' | 'executive'
  invited: string
  participating: string
  removed: string
  removing: string
}

export interface CorpUserType{
  muid: string
  email: string
  name: string
  onboarding_date: string
  records_found: string
  records_removed: string
  records_removing: string
  first_scan_complete: string
  blast_emails_sent: string
  code: string
  subscription_status: string
  expire_time: string
}

export const CompanyNameOptions : string[] = []

export const dateRangeFilter={
    dateFilter: false,
    startDate: false,
    endDate: false,
}

export const lastSyncInitialState: Record<string,string>[] = [
    {
        "users_report.parquet": ""
    },
    {
        "subscription_reporting_stats.parquet": ""
    },
    {
        "account_subscription_creation_stats.parquet": ""
    },
    {
        "company_report.parquet": ""
    },
    {
        "corp_users_report.parquet": ""
    },
    {
        "removals_report.parquet": ""
    }
]

export const lastSyncFormattedInitialState: Record<string,string> =
    {
        "users_report.parquet": "",
        "subscription_reporting_stats.parquet": "",
        "account_subscription_creation_stats.parquet": "",
        "company_report.parquet": "",
        "corp_users_report.parquet": "",
        "removals_report.parquet": "",
        "family_report.parquet": "",
        "individual_user_report.parquet":""
    }


export type RemovalStatsType = {
  "onerep":number, "meprism":number,"total":number,"4ScreenMedia":number,"rocketreach":number
}

export type BrokerSourceType = "onerep"|"meprism"|"4ScreenMedia"|"rocketreach"

export const BrokerSourceOptions : BrokerSourceType[] = ["onerep","meprism","4ScreenMedia","rocketreach"]

export const BrokerSourceStatsInitialState : RemovalStatsType = {"onerep":0,"meprism":0,"total":0,"4ScreenMedia":0,"rocketreach":0}

export const AllCorporateStatsInitialState: Record<string,number | RemovalStatsType> = 
    {
          "total_codes": 0,
          "total_corporate_users": 0,
          "total_removed": BrokerSourceStatsInitialState,
          "total_removing": BrokerSourceStatsInitialState
    }

export const AllFamilyStatsInitialState: Record<string,number|RemovalStatsType> = 
  {
    "total_parents": 0,
    "total_children": 0,
    "total_records_found": BrokerSourceStatsInitialState,
    "total_records_removed": BrokerSourceStatsInitialState,
    "total_records_removing": BrokerSourceStatsInitialState
  }

export type FamilySortByType = 'parent_subscription_expire_time'|'parent_email' | 'parent_onboarding_date' | 'parent_name'| 'parent_records_found' | 'parent_records_removed' | 'parent_records_removing' | 'subscription_tier'

export interface FamilyUsersType{
  parent_muid: string
  parent_email: string
  parent_name: string
  parent_onboarding_date: string
  parent_records_found: string
  parent_records_removed: string
  parent_records_removing: string
  parent_first_scan_complete: string
  parent_blast_emails_sent: string
  parent_subscription_status: string
  parent_subscription_expire_time: string
  child_muid: string
  child_email: string
  child_name: string
  child_onboarding_date: string
  child_records_found: string
  child_records_removed: string
  child_records_removing: string
  child_first_scan_complete: string
  child_blast_emails_sent: string
  child_subscription_status: string
  child_subscription_expire_time: string
  subscription_tier: string | null
}

export type UsersRangeFilterType = "Onboarding Date" | "Expire Date"

export const UsersRangeFilterOptions = ["Onboarding Date" , "Expire Date"]

export const FamilyReportRangeFilterMapper = {
  "Onboarding Date":'parent_onboarding_date' , "Expire Date" : "parent_subscription_expire_time"
} as const

export type IndivdualReportSortByType = 'email'|'onboarding_date'|'name' | 'expire_time'|'records_found'|'records_removed'| 'records_removing' | 'subscription_tier'

export interface AllIndividualStatsType {
  "total_individual_users": number,
  "total_records_found": RemovalStatsType,
  "total_records_removed": RemovalStatsType,
  "total_records_removing": RemovalStatsType
}

export const AllIndividualStatsInitialState : AllIndividualStatsType = 
  {
    "total_individual_users": 0,
    "total_records_found": BrokerSourceStatsInitialState,
    "total_records_removed": BrokerSourceStatsInitialState,
    "total_records_removing": BrokerSourceStatsInitialState
  }

export type IndividualUserType = {
  muid: string
  email: string
  name: string
  onboarding_date: string
  records_found: string
  records_removed: string
  records_removing: string
  first_scan_complete: string
  blast_emails_sent: string
  subscription_status: string
  expire_time: string
  subscription_tier: string | null
}

export type searchFilterType = 'Muid' | 'Name' | 'Email' | 'First Name' | 'Last Name'

export const SearchFilterOptions : searchFilterType[] = ['Muid' , 'Name' , 'Email', 'First Name' , 'Last Name']  